import { useQuery } from 'react-query';

import type { LedgerBillingOverviewResponseDto } from '../../../../backend/src/usage/dto/ledger-billing-overview.response.dto';
export type {
  LedgerUsageBreakdownDto as LedgerUsageBreakdown,
  LedgerUsageTableRowDto as LedgerUsageTableRow,
  LedgerUsageTimePointDto as LedgerUsageTimePoint,
} from '../../../../backend/src/usage/dto/ledger-billing-overview.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export function useGetLedgerBillingOverview(
  organisationId: string,
  filters: { startDate?: string; endDate?: string } = {},
  enabled = true,
) {
  const fetcher = useFetcher();
  const { startDate, endDate } = filters;

  return useQuery<LedgerBillingOverviewResponseDto>(
    [QueryEntity.LedgerBillingOverview, { organisationId, startDate, endDate }],
    () => {
      const url = new URL(`${APIBaseChronos}/api/usage/ledger-billing-overview`);
      url.searchParams.append('organisationId', organisationId);
      if (startDate && endDate) {
        url.searchParams.append('startDate', startDate);
        url.searchParams.append('endDate', endDate);
      }
      return fetcher(url.toString());
    },
    { enabled: enabled && organisationId !== '', keepPreviousData: true, refetchOnWindowFocus: false },
  );
}
